type PromptBodyPreviewProps = {
  body: string;
  className?: string;
  variableClassName?: string;
};

export function PromptBodyPreview({
  body,
  className,
  variableClassName = 'mx-0.5 inline-flex items-center rounded-md border border-dashed border-border/80 bg-muted/80 px-1.5 py-0.5 text-xs font-medium text-foreground',
}: PromptBodyPreviewProps) {
  const parts = body.split(/(\{\{\s*[^}]+\s*\}\})/g);

  return (
    <p className={className}>
      {parts.map((part, index) => {
        const variableMatch = part.match(/^\{\{\s*([^}]+?)\s*\}\}$/);
        if (variableMatch) {
          const name = variableMatch[1]?.trim() || '';
          return (
            <span key={`var-${index}`} className={variableClassName}>
              {name}
            </span>
          );
        }
        if (!part) return null;
        return <span key={`text-${index}`}>{part}</span>;
      })}
    </p>
  );
}
